import axiosInstance from "../axiosInstance";

const BASE = "/settings/usage-roles";

export const getUsageRolePresets = async () => {
  const res = await axiosInstance.get(`${BASE}/presets`);
  return res.data;
};

export const getUsageRoleCatalog = async () => {
  const res = await axiosInstance.get(`${BASE}/catalog`);
  return res.data;
};

export const getUsageRoles = async (params = {}, config = {}) => {
  const cleaned = Object.fromEntries(
    Object.entries(params).filter(
      ([, v]) => v !== undefined && v !== null && v !== ""
    )
  );
  const query = new URLSearchParams(cleaned).toString();
  const res = await axiosInstance.get(query ? `${BASE}?${query}` : BASE, config);
  return res.data;
};

export const getUsageRoleOptions = async (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const res = await axiosInstance.get(`${BASE}/options?${query}`);
  return res.data;
};

export const getUsageRoleById = async (id) => {
  const res = await axiosInstance.get(`${BASE}/${id}`);
  return res.data;
};

export const createUsageRole = async (payload) => {
  const res = await axiosInstance.post(BASE, payload);
  return res.data;
};

export const updateUsageRole = async (id, payload) => {
  const res = await axiosInstance.put(`${BASE}/${id}`, payload);
  return res.data;
};

/** Đồng bộ cấu hình quyền từ nguồn sang các quyền được chọn */
export const propagateUsageRole = async (id, targetIds = []) => {
  const res = await axiosInstance.post(`${BASE}/${id}/propagate`, {
    target_ids: targetIds,
  });
  return res.data;
};

export const getUsageRoleStats = async () => {
  const res = await axiosInstance.get(`${BASE}/stats`);
  return res.data;
};

export const getUsageRoleLogs = async (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const res = await axiosInstance.get(`${BASE}/logs?${query}`);
  return res.data;
};

export const deleteUsageRole = async (id) => {
  const res = await axiosInstance.delete(`${BASE}/${id}`);
  return res.data;
};
